import React, { PureComponent } from 'react'
import {
    Divider,
    Typography,
} from '@material-ui/core'
import { geographyMenuItems } from 'shared/helpers';
import Dropdown from 'shared/components/Dropdown'
import SwitchPanel from 'bundles/Dashboard/components/SwitchPanel'

const classes = {
    formControl: {
        width: '100%',
    },
    divider: {
        margin: '15px 0',
    },
    h7: {
        fontSize: '1.10rem',
        fontWeight: '400',
    },
}
class Layers extends PureComponent {
    // componentWillMount() {

    // }

    render() {
        const {
            switches: {
                // earlyEducation,
                foodDeserts,
                transportation,
                transit,
                // lowIncomeTenants,
                affordableUnits,
                risingRents,
                // gentrification,
                race,
                income,
            },
            displayGeography,
            handleChange,
            handleSwitch,
            handleLayerFilter,
            foodDesertData,
            transportationData,
            transitData,
            lossAffordableHousingData,
            risingRentData,
            raceData,
            transportationDataFilterRange,
            foodDesertDataFilterRange,
            lossAffordableHousingDataFilterRange,
            risingRentDataFilterRange,
            raceDataFilterRange,
            incomeDataFilterRange,
            transitDataFilterChoice,
            setChoiceForTransitLayer
        } = this.props;

        const switchData = [
            [
                // {
                //     stateVariable: earlyEducation,
                //     value: 'earlyEducation',
                //     label: 'Early Education',
                //     tooltip: 'This is some placeholder text',
                // },
                {
                    stateVariable: transportation,
                    value: 'transportation',
                    label: 'Transportation',
                    tooltip: 'Percentage of commutes under 25 minutes by census tract',
                    geoData:transportationData,
                    layerData:'transportationDataFilter',
                    dataFieldName: 'Pct_Trav_1',
                    displayByBarchart:true
                },
                {
                    stateVariable: foodDeserts,
                    value: 'foodDeserts',
                    label: 'Food Deserts',
                    tooltip: 'Census tract level data on food access indicators for low-income and other census tracts using different measures of supermarket accessibility (Source: USDA)',
                    geoData: foodDesertData,
                    layerData:'foodDesertDataFilter',
                    dataFieldName: 'LILATracts',
                    displayByBarchart:true
                },
                {
                    stateVariable: transit,
                    value: 'transit',
                    label: 'Transit',
                    tooltip: 'Location of rail stations within Fulton County (Source: Fulton County)',
                    geoData:transitData,
                    layerData:'transitDataFilter',
                    dataFieldName: 'BUFF_DIST',
                    displayByBarchart:false
                }
            ],
            [
                // {
                //     stateVariable: lowIncomeTenants,
                //     value: 'lowIncomeTenants',
                //     label: '% Low Income Tenants',
                //     tooltip: 'This is some placeholder text',
                // },
                {
                    stateVariable: affordableUnits,
                    value: 'affordableUnits',
                    label: 'Loss of Affordable Units',
                    tooltip: 'Sum of all units within a census tract rented at or below “affordable” level ($750/month) in 2017 subtracted by the sum in 2012 (Source: ACS 5 Year Estimate)',
                    geoData:lossAffordableHousingData,
                    layerData:'lossAffordableHousingDataFilter',
                    dataFieldName: 'aCHNG_UN_7',
                    displayByBarchart:true
                },
                {
                    stateVariable: risingRents,
                    value: 'risingRents',
                    label: 'Rising Rents',
                    tooltip: 'Change in rent over a 3 year time frame with a June-to-June comparison, displayed at percentage increments (Source: Zillow)',
                    geoData:risingRentData,
                    layerData:'risingRentDataFilter',
                    dataFieldName: 'diff2014_1',
                    displayByBarchart:true
                },
                // {
                //     stateVariable: gentrification,
                //     value: 'gentrification',
                //     label: 'Gentrification',
                //     tooltip: 'This is some placeholder text',
                // },
            ],
            [
                {
                    stateVariable: race,
                    value: 'race',
                    label: 'Race',
                    tooltip: 'Percentage of Black or African American residents of a census tract (Source: ACS 5 Year Estimate)',
                    geoData:raceData,
                    layerData:'raceDataFilter',
                    dataFieldName: 'BlackNum',
                    displayByBarchart:true
                },
                {
                    stateVariable: income,
                    value: 'income',
                    label: 'Income',
                    tooltip: 'Median Household Income in the past 12 months (Source: ACS 5 Year Estimate)',
                    geoData:raceData,
                    layerData:'raceDataFilter',
                    dataFieldName: 'MedIncNum',
                    displayByBarchart:true
                }
            ]
        ];

        // console.log(switchData)

        return (
            <div className="filter-container">
                <div className="content">
                    <div className="container-fluid card-with-padding">
                        <div className="row row-spacing">
                            <div className="col">
                                <Typography variant="h6" style={classes.h7}>
                                    Display Geography
                                    </Typography>
                                <Dropdown
                                    data={{
                                        value: displayGeography,
                                        name: 'displayGeography',
                                        menuItems: geographyMenuItems,
                                    }}
                                    handleChange={handleChange}
                                />
                            </div>
                        </div>
                        <Divider style={classes.divider} />
                        <SwitchPanel
                            title="Opportunity and Access"
                            data={switchData[0]}
                            handleSwitch={(e) => { handleSwitch(e) }}
                            handleLayerFilter = {handleLayerFilter}
                            transportationDataFilterRange={transportationDataFilterRange}
                            foodDesertDataFilterRange={foodDesertDataFilterRange}
                            lossAffordableHousingDataFilterRange={lossAffordableHousingDataFilterRange}
                            risingRentDataFilterRange={risingRentDataFilterRange}
                            raceDataFilterRange={raceDataFilterRange}
                            incomeDataFilterRange={incomeDataFilterRange}
                            transitDataFilterChoice={transitDataFilterChoice}
                            setChoiceForTransitLayer = {setChoiceForTransitLayer}
                        />
                        <Divider style={classes.divider} />
                        <SwitchPanel
                            title="Affordability Loss Indicators"
                            data={switchData[1]}
                            handleSwitch={(e) => { handleSwitch(e) }}
                            handleLayerFilter = {handleLayerFilter}
                            transportationDataFilterRange={transportationDataFilterRange}
                            foodDesertDataFilterRange={foodDesertDataFilterRange}
                            lossAffordableHousingDataFilterRange={lossAffordableHousingDataFilterRange}
                            risingRentDataFilterRange={risingRentDataFilterRange}
                            raceDataFilterRange={raceDataFilterRange}
                            incomeDataFilterRange={incomeDataFilterRange}
                        />
                        <Divider style={classes.divider} />
                        <SwitchPanel
                            title="Demographics"
                            data={switchData[2]}
                            handleSwitch={(e) => { handleSwitch(e) }}
                            handleLayerFilter = {handleLayerFilter}
                            transportationDataFilterRange={transportationDataFilterRange}
                            foodDesertDataFilterRange={foodDesertDataFilterRange}
                            lossAffordableHousingDataFilterRange={lossAffordableHousingDataFilterRange}
                            risingRentDataFilterRange={risingRentDataFilterRange}
                            raceDataFilterRange={raceDataFilterRange}
                            incomeDataFilterRange={incomeDataFilterRange}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default Layers